import React, { memo, useCallback } from 'react';
import { MODAL_SIZES, WIDTH } from 'shared-modules/constants';
import { useDispatch, useSelector } from 'react-redux';
import { convertErrorCodeToText, useOmakasePlanRunConfirm } from 'shared-modules/services/hooks/omakasePlanLogic';
import { CONFIRM_MODAL_INFO, CONFIRM_MODAL_NAME_TEXT } from 'shared-modules/constants/omakasePlan';
import { Modal, Button, InputText } from '../../../../../components';
import styles from './confirmModal.module.scss';
import { StrategyInfo } from './StrategyInfo/StrategyInfo';
import {
  closeOmakaseConfirmModal,
  closeOmakaseResultModal,
  openOmakaseResultModal,
} from '../../../../../redux/actions/modalActions';

export const ConfirmModal = memo(() => {
  const dispatch = useDispatch();
  const { isOpen: isOpenOmakaseConfirm } = useSelector((s) => s.modals.openOmakaseConfirmModal);

  const closeResultModal = useCallback(() => {
    dispatch(closeOmakaseResultModal());
  }, [dispatch]);

  const successCallback = useCallback(() => {
    dispatch(closeOmakaseConfirmModal());
    dispatch(openOmakaseResultModal({ type: 'success', closeModal: closeResultModal }));
  }, [dispatch, closeResultModal]);

  const failureCallback = useCallback(
    ({ type, failedList, succeededList } = {}) => {
      dispatch(closeOmakaseConfirmModal());
      dispatch(
        openOmakaseResultModal({
          type,
          errorInfo: convertErrorCodeToText({ type, failedList, succeededList }),
          closeModal: closeResultModal,
        }),
      );
    },
    [dispatch, closeResultModal],
  );

  const marginErrorCallback = useCallback(
    ({ currentOrderableMargin, marginRequired, shortfall }) => {
      dispatch(closeOmakaseConfirmModal());
      dispatch(
        openOmakaseResultModal({
          type: 'margin',
          errorInfo: { currentOrderableMargin, marginRequired, shortfall },
          closeModal: closeResultModal,
        }),
      );
    },
    [dispatch, closeResultModal],
  );

  const { nameInput, strategyList, runNowBtn } = useOmakasePlanRunConfirm({
    successCallback,
    failureCallback,
    marginErrorCallback,
  });

  return (
    <Modal
      isOpen={isOpenOmakaseConfirm}
      closeModal={() => dispatch(closeOmakaseConfirmModal())}
      centered
      size={MODAL_SIZES.WIDTH_400_HEIGHT_720}
      title="確認画面"
      isOverlap
      isOutsideClickDontClose
    >
      <div className={styles.bodyContainer}>
        <div className={styles.nameInputContainer}>
          <div className={styles.nameText}>{CONFIRM_MODAL_NAME_TEXT}</div>
          <div className={styles.nameInput}>
            <InputText
              inputClassName={styles.input}
              width={WIDTH.PERCENTAGE_100}
              value={nameInput.get}
              onChange={nameInput.set}
              name={nameInput.name}
              errorMessages={nameInput.error}
              validateFunction={nameInput.validation}
              withErrorTooltip
            />
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.strategyListContainer}>
          {strategyList.map((item) => (
            <StrategyInfo strategy={item} key={item.strategyId} />
          ))}
        </div>
        <hr className={styles.divider} />
        <div className={styles.descriptionText}>{CONFIRM_MODAL_INFO}</div>
        <div className={styles.buttonContainer}>
          <Button className={styles.confirmButton} green disabled={runNowBtn.isDisabled} onClick={runNowBtn.onClick}>
            {runNowBtn.label}
          </Button>
        </div>
      </div>
    </Modal>
  );
});
